const blogFilterLinks = document.querySelectorAll('.blog-article-filter a');
const blogFilterSelect = document.querySelector('.blog-article-filters--mobile');
const blogFilterOptions = document.querySelectorAll('.blog-article-filters--mobile option');

// remove 'filter:' from blog filter links - DESKTOP
blogFilterLinks.forEach((link) => {
  link.textContent = link.textContent.replace('filter:', '');
} );

// add active class to blog filter links if url contans blog filter text
blogFilterLinks.forEach((link) => {
  const filter = link.textContent.replace(' ', '-');
  const allArticlesfilter = document.querySelector('.blog-article-filter--all-articles');
  if(getSecondPart(window.location.href)) {
    if (getSecondPart(window.location.href).replace('filter-', '') == filter.toLowerCase()) {
      link.parentNode.classList.add('active');
      allArticlesfilter.classList.remove('active');
    }
  }
});

// remove 'filter:' from blog filter options - MOBILE
blogFilterOptions.forEach((option) => {
  option.textContent = option.textContent.replace('filter:', '');

  option.value = option.value.replace(' ', '-');
  option.value = option.value.replace('filter', 'filter-');
  if(getSecondPart(option.value)) {
    if (getSecondPart(option.value) === getSecondPart(window.location.href)) {
      blogFilterSelect.value = `/blogs/news/tagged/${getSecondPart(window.location.href)}`;
    } 
  } else {
    blogFilterSelect.value == '/blogs/news'
  }

  blogFilterSelect.addEventListener('change', (e) => {
    window.location.href = e.target.value;
  })
})

// helper function to get second part of url
function getSecondPart(str) {
  return str.split('tagged/')[1];
}